/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatusInfo } from './AdmissionStatusInfo';
import {
    AdmissionStatusInfoFromJSON,
    AdmissionStatusInfoFromJSONTyped,
    AdmissionStatusInfoToJSON,
} from './AdmissionStatusInfo';

/**
 * 
 * @export
 * @interface AdmissionDetails
 */
export interface AdmissionDetails {
    /**
     * 
     * @type {string}
     * @memberof AdmissionDetails
     */
    bed_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdmissionDetails
     */
    admission_status?: string;
    /**
     * 
     * @type {AdmissionStatusInfo}
     * @memberof AdmissionDetails
     */
    admission_status_info?: AdmissionStatusInfo | null;
}

/**
 * Check if a given object implements the AdmissionDetails interface.
 */
export function instanceOfAdmissionDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdmissionDetailsFromJSON(json: any): AdmissionDetails {
    return AdmissionDetailsFromJSONTyped(json, false);
}

export function AdmissionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdmissionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bed_name': !exists(json, 'bed_name') ? undefined : json['bed_name'],
        'admission_status': !exists(json, 'admission_status') ? undefined : json['admission_status'],
        'admission_status_info': !exists(json, 'admission_status_info') ? undefined : AdmissionStatusInfoFromJSON(json['admission_status_info']),
    };
}

export function AdmissionDetailsToJSON(value?: AdmissionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bed_name': value.bed_name,
        'admission_status': value.admission_status,
        'admission_status_info': AdmissionStatusInfoToJSON(value.admission_status_info),
    };
}

